<div class="container-fluid">
  <div class="row">
    <div class="col d-flex justify-content-end py-2">
      <button mat-stroked-button (click)="firstAccordion.closeAll(); secondAccordion.closeAll(); thirdAccordion.closeAll(); fourthAccordion.closeAll(); fifthAccordion.closeAll(); sixthAccordion.closeAll(); seventhAccordion.closeAll(); eighthAccordion.closeAll(); ninthAccordion.closeAll(); tenthAccordion.closeAll(); eleventhAccordion.closeAll()">Collapse All</button>
      <button mat-stroked-button (click)="firstAccordion.openAll(); secondAccordion.openAll(); thirdAccordion.openAll(); fourthAccordion.openAll(); fifthAccordion.openAll(); sixthAccordion.openAll(); seventhAccordion.openAll(); eighthAccordion.openAll(); ninthAccordion.openAll(); tenthAccordion.openAll(); eleventhAccordion.openAll()">Expand All</button>
    </div>
  </div>
  <div class="row">
    <div class="col">
        <!--  Question 1  -->
          <mat-accordion #firstAccordion="matAccordion" multi>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Why don’t I see all of my contracts containing volumes guarantees present in the AccessNS portal?
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p>Your contract could be expired. Check the termination date on your executed agreement copy. If its expired and you would like to renew, please contact your Marketing representative to negotiate an amendment to extend.</p>
              <div class="row">
                <div class="col-6"><a href="https://www.norfolksouthern.com/en/ship-by-rail/industry/agriculture-forest" target="_blank">Agriculture & Forest Marketing</a></div>
                <div class="col-6"><a href="https://www.norfolksouthern.com/en/ship-by-rail/industry/coal" target="_blank">Coal Marketing</a></div>
              </div>
              <div class="row">
                <div class="col-6"><a href="https://www.norfolksouthern.com/en/ship-by-rail/industry/automotive" target="_blank">Automotive Marketing</a></div>
                <div class="col-6"><a href="https://www.norfolksouthern.com/en/ship-by-rail/industry/intermodal" target="_blank">Intermodal Marketing</a></div>
              </div>
              <div class="row">
                <div class="col-6"><a href="https://www.norfolksouthern.com/en/ship-by-rail/industry/chemicals" target="_blank">Chemicals Marketing</a></div>
                <div class="col-6"><a href="https://www.norfolksouthern.com/en/ship-by-rail/industry/metals-construction" target="_blank">Metals & Construction Marketing</a></div>
              </div>
              <p class="pt-3">If your agreement is not expired, it may not be ready to be loaded into the new system.
                Our new contract management system is still in its infancy. We are constantly
                working to enhance the system to accommodate every contract structure so that all contracts can be present.
                Please feel free to contact Contract Compliance (<a href="mailto:contcomp@nscorp.com">contcomp@nscorp.com</a>) for more
                details on why a specific contract may not be represented in the portal.</p>
            </mat-expansion-panel>
          </mat-accordion>
        <!--  Question 2  -->
          <mat-accordion #secondAccordion="matAccordion" multi>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Why can’t I see all the previous volume periods for my contracts?
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p>The portal in AccessNS only captures volume periods that are integrated and managed via the new system. Each contract period will stay visible in the portal for 60 days beyond the contract expiration date. </p>
              <p>Historical volumes managed through our legacy contract management process will not be visible. If you have questions about historical volume data, please contact your NS Marketing representative or Contract Compliance (<a href="mailto:contcomp@nscorp.com">contcomp@nscorp.com</a>). </p>
            </mat-expansion-panel>
          </mat-accordion>
        <!--  Question 3  -->
          <mat-accordion #thirdAccordion="matAccordion" multi>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  What happens when one of my contacts leaves my company?
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p>If one of your contacts separates from your company, it’s important to let us know so we can protect your confidential information.
                Please contact Contract Compliance (<a href="mailto:contcomp@nscorp.com">contcomp@nscorp.com</a>)
                as soon as possible to have their access removed. Please be sure to include their full name, email address, and AccessNS user id in your request.</p>
            </mat-expansion-panel>
          </mat-accordion>
        <!--  Question 4  -->
          <mat-accordion #fourthAccordion="matAccordion" multi>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  What does ‘Volume Period in Progress’ mean?
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p>This status is displayed while the volume period is still occurring.
                A volume period is most typically from effective date to expiration date; however,
                the exact volume period will be defined in the contract language of each specific contract.</p>
            </mat-expansion-panel>
          </mat-accordion>
        <!--  Question 5  -->
          <mat-accordion #fifthAccordion="matAccordion" multi>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Why does my Volume Period in Progress show ‘Likely to Miss Target Volume’?
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p>The <strong>Volume Gauge</strong> is an estimate of how the volume period is progressing based on the current pace of traffic.
                Norfolk Southern cannot predict exactly how and when traffic will move.
                The gauge is just a tool to provide insight into how the current pace of volume compares with the commitment for the period.</p>
              <p>To rate the likelihood of reaching the commitment,
                the system annualizes the current volume - comparing the actual units shipped with the time remaining
                in the period to forecast the total volume achievement: </p>
              <ul>
                <li>
                  If the annualized traffic is found to be <strong>less than 80%</strong> of the minimum requirement, the case is rated <strong>Likely to Miss</strong>.
                </li>
                <li>
                  If the annualized traffic is found to be <strong>between 80%-99%</strong> of the minimum requirement, the case is rated <strong>Unsure</strong>.
                </li>
                <li>
                  If the annualized traffic is found to be <strong>greater than or equal</strong> to the minimum requirement, the case is rated <strong>Likely to Meet</strong>.
                </li>
              </ul>
              <p class="pt-3">Please keep in mind, some shipments may not yet appear due to the typical lag time between
                shipment and billing. Consequently, your company records may reflect you are closing to meeting the
                requirement than NS records. All qualifying shipments will be considered during volume reconciliation
                throughout the life cycle of the contract.</p>
              <p>Please review the specific terms of your executed agreement. If no carloads are present, but you believe
                you’ve shipped qualifying loads, please click <strong>Contact US</strong> on the volume case.</p>
            </mat-expansion-panel>
          </mat-accordion>
        <!--  Question 6  -->
          <mat-accordion #sixthAccordion="matAccordion" multi>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Why does my volume case show an ‘Agreement Not Signed‘?
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p>Norfolk Southern accounting controls require that all volume agreements be fully executed by both the
              customer and NS. If your volume case status reflects a yellow <strong>Agreement Not Signed</strong> tag, it means that the
              agreement covering the volume period is not yet executed by both parties.
              Please contact your Marketing representative to get an update on the status of your agreement.</p>
            </mat-expansion-panel>
          </mat-accordion>
        <!--  Question 7  -->
          <mat-accordion #seventhAccordion="matAccordion" multi>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  The volume period has ended but the status shows "Volume Period in Progress" and qualifying candidates appear to be missing from the volume case. What do I do?
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p>Let’s talk about timing. At the end of the volume period, the new system keeps the case in
                <strong>Period in Progress</strong> status for an additional <strong>28 days</strong>. The 28-day window was designed to allow any
                qualifying candidates that ship at the end of the period to make their way through the billing process.
                This helps maximize the shipments counted in the volume period, thus reducing any potential shortfall
                that could result in liquidated damages.</p>
              <p>If you are viewing your volume case during the 28-day window, please keep in mind that candidates will
                continue to populate. After the 28-day window closes, the volume case moves to a Customer Review Period</p>
              <p>If you believe qualifying candidates shipped at any point during the volume period are not present but
                should be, please click <strong>Contact Us</strong> on the volume case to notify Contract Compliance. Please provide a
                list of shipments – including car initial, car number, and ship date. Contract Compliance will work to
                incorporate any missing cars into the current volume period.</p>
            </mat-expansion-panel>
          </mat-accordion>
        <!--  Question 8  -->
          <mat-accordion #eighthAccordion="matAccordion" multi>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  My volume case has been in ‘Under NS Review’ status for a long time. What’s going on?
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p>Our new volume system is still in its infancy. As with any new system, bugs can present unforeseen
                delays. We are constantly working to enhance the system to provide the best experience for our customers.</p>
              <p>We value your feedback! If you notice anything that seems out of place or incorrect, please don’t
                hesitate to click the <strong>Contact US</strong> button or email Contract Compliance (<a href="mailto:contcomp@nscorp.com">contcomp@nscorp.com</a>).</p>
              <p>If you have any questions on what is causing the delay, please contact Contract Compliance.</p>
            </mat-expansion-panel>
          </mat-accordion>
      <!--  Question 9  -->
      <mat-accordion #ninthAccordion="matAccordion" multi>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              What happens when the period is complete?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p>Once the period is complete, you will receive <strong>an automatic email notification</strong> letting you
            know your volume is ready for review and acceptance and/or certification.</p>
          <ul>
            <li>
              If you have <strong>MET</strong> the Volume Guarantee specified in the contract language, the volume
                case moves to <strong>Closed</strong> status and there is nothing else required for you to do.
            </li>
            <li>
              If you have <strong>NOT MET</strong> the Volume Guarantee specified in the contract language, you will
              be asked to review the qualifying volume listed on the case and <strong>Accept</strong> the liquidated damages.
            </li>
            <li>
              If your contract requires a specific <strong>Percentage</strong> of traffic be shipped via Norfolk Southern, you must Certify that the number of qualifying carloads shipped during the contract period is <strong>at or above the required percentage</strong>.
              To complete certification, click the Certify button. You will be asked to enter the percentage of rail shipments you shipped with Norfolk Southern during the volume period.
            </li>
          </ul>
          <p class="pt-3">If you believe the volume case is missing qualifying candidates, you can opt to file a
            <strong>Dispute</strong>. During the dispute process, we ask that you please <strong>Upload</strong>
            a list of missing shipments – including car initial, car number, and ship date. Contract Compliance will
            work to incorporate any missing cars into the current volume period.</p>
        </mat-expansion-panel>
      </mat-accordion>
      <!--  Question 10  -->
      <mat-accordion #tenthAccordion="matAccordion" multi>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              What do I do if I believe the Liquidated Damages amount is incorrect?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p>If you disagree with the liquidated damages presented at the end of the volume period, you can file a
            <strong>Dispute</strong> by clicking the Dispute button on the volume case. Be sure to provide
            <strong>Comments</strong>. as to the reason(s) for your dispute. To aid us in resolving your dispute,
            we kindly ask that you also <strong>Upload</strong> any pertinent documentation to help support your
            claim so we can expedite a resolution. An example of this would be providing a list of missing qualifying
            cars or attaching an email explaining a NS service issues or Force Majeure event.
            You will also be asked to specify the amount of liquidated damages you believe are owed,
            if different from the calculation provided.</p>
          <p>Your NS Marketing representative will review the dispute and contact you to resolve.</p>

        </mat-expansion-panel>
      </mat-accordion>
      <!--  Question 11  -->
      <mat-accordion #eleventhAccordion="matAccordion" multi>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              What happens after I Accept the Liquidated Damages?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p>When you click <strong>Accept</strong>, you will be asked to provide a <strong>physical street address</strong> and <strong>email address</strong>
            we kindly ask that so we can direct the invoice to the correct location/person.</p>
          <p>Contract Compliance will be notified of your acceptance. We will then work with Norfolk Southern Revenue
            Accounting to create an <strong>Invoice</strong> for the liquidated damages and ensure it is sent to the requested location/person.</p>
          <p>Payment can be remitted to Norfolk Southern – referencing the invoice number – via check or electronically.
            Information regarding payment methods can be found in the <strong>Ways to Pay</strong> section located on
            our <a href="https://www.norfolksouthern.com/en/ship-by-rail/shipping-tools/business-solutions/billing-financing" target="_blank">Business Solutions</a> webpage.</p>
          <p>Once payment is received and posted, the volume case will move to <strong>Closed</strong> status and there is nothing else
            required for you to do.</p>

        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
